import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as qs from "qs";
import axiosApi from "../../utils/httpClient";
const name = "receivedEvents";
const initialState = {
  receivedEvents: [],
  loading: false,
  error: null,
};

export const receivedEventsAPI = createAsyncThunk(
  "receivedEvents",
  async ({ search, skip, limit, id }) => {
    var formData = {};

    const data = await axiosApi.get(
      `${
        process.env.REACT_APP_BASE_URL
      }event/recevied-interests/${id}?skip=${skip}&limit=${limit}${
        search != "" ? `&search=${search}` : ""
      }`,
      {
        params: formData,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      }
    );
    return data.data;
  }
);

const receivedEventsSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(receivedEventsAPI.pending, (state) => {
      state.receivedEvents = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(receivedEventsAPI.fulfilled, (state, action) => {
      state.receivedEvents = action.payload.data;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(receivedEventsAPI.rejected, (state, action) => {
      state.receivedEvents = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default receivedEventsSlice.reducer;
